const _ = "styles-module__button___7i-pH", l = "styles-module__hide_label_on_mobile___5UVBF", e = "styles-module__label___0gBwq", o = {
  button: _,
  hide_label_on_mobile: l,
  label: e
};
export {
  _ as button,
  o as default,
  l as hide_label_on_mobile,
  e as label
};
